const { ConsentValue } = require('../constants/consentValue');

const getConsentModeValue = function(value) {
  return value.filter(val => !val).length === 0 ? ConsentValue.Allowed : ConsentValue.Denied;
};

module.exports = { getConsentModeValue };
